<template>
    <div>
        <v-card color="#006064" dark class="mx-auto rounded-lg mr-2" outlined>
            <v-card-title class="text-sm-left">
                <v-icon left>people</v-icon>
                Fila Médica
            </v-card-title>
            <v-card-text>
                <v-select
                    :items="medicos"
                    item-text="nome"
                    return-object
                    label="Médico"
                    v-model="medico"
                    dense
                    class="mt-2"
                    >
                </v-select>
            </v-card-text>
        </v-card>
    </div>
    </template>
<script>
import filaMedicaService from '../../services/filaMedicaService'
export default {
  name: 'lista-medicos',

  props: {
    medico: {
      type: Object
    }
  },
  data () {
    return {
      medicos: [],
      user: null
    }
  },
  methods: {
    carregarListaMedicas () {
      filaMedicaService.filaMedica.listarMedicos(this.user.idEmpresa, this.user.idUnidade).then((response) => {
        if (response.status == 200) {
          this.medicos = response.data
        }
      })
    }
  },
  mounted () {
    this.user = this.$store.getters.usuario
    this.carregarListaMedicas()
  },
  watch: {
    medico: function (val) {
      this.$emit('medicoSelecionado', val)
    }
  }
}
</script>
